<template>
  <transition name="fade">
    <div v-if="isAddElementLoading" class="common-shadow-loader">
      <Loader/>
    </div>
  </transition>

  <div class="add-element">
    <div class="input-with-cross">
      <label for="search-input" class="search-logo ic-search"></label>
      <input id="search-input" v-model="filterValue" type="text" class="form-control" placeholder="Поиск">
      <span v-if="filterValue" class="ic-cross" @click="filterValue = ''"></span>
    </div>

    <div v-if="modelValue" class="elements">

      <div class="elements-not-found" v-if="freeElements.length === 0">
        Элементы не найдены
      </div>

      <add-element-accordion-form v-else-if="filterValue" v-model="elementForm" :elements="freeElements"/>

      <Accordion v-else :elements="freeElements">
        <template v-slot:title="{element}">
          {{ element.name }}
        </template>
        <template v-slot:body="{element}">

          <add-element-accordion-form :elements="element.elements" v-model="elementForm"/>

        </template>
      </Accordion>
    </div>

    <div class="buttons">
      <button @click="submitFormAndClose" :disabled="disableSubmitButton" class="btn btn-primary">Добавить</button>
      <button @click="submitForm" :disabled="disableSubmitButton" class="btn btn-primary">Добавить и продолжить</button>
      <button class="btn btn-primary" @click="closeModal">Закрыть</button>
    </div>

  </div>

</template>

<script>
import UseAddElement from "@/composables/crudElements/UseAddElement";
import Accordion from "@/components/common/Accordion";
import Loader from "@/components/common/Loader";
import AddElementAccordionForm from "@/components/crudElements/AddElementAccordionForm";

export default {
  name: "AddElement",
  components: {AddElementAccordionForm, Loader, Accordion},
  props: {
    modelValue: {
      type: Boolean
    },
  },
  computed: {
    disableSubmitButton() {
      return !this.elementForm.value || this.errors.value
    }
  },
  data() {
    return {
      elementForm: {
        value: undefined,
        element: undefined
      }
    }
  },
  setup() {
    return {
      ...UseAddElement()
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:modelValue', false)
    },
    submitForm() {
      return this.addElement(this.elementForm)
        .then(() => {
          this.elementForm.value = undefined
          this.elementForm.element = undefined
        })
    },
    submitFormAndClose() {
      this.submitForm()
        .then(this.closeModal)
    }
  },
  watch: {
    modelValue(val) {
      if (!val) {
        this.filterValue = ''
      }
    },
    'elementForm.value': {
      handler() {
        this.clearValueError()
      }
    }

  }

}
</script>

<style lang="scss" scoped>

.add-element {

  .elements {
    max-height: 50vh;
    overflow-y: scroll;
    margin: 10px 0;
  }

  .buttons {
    display: flex;
    flex-direction: column;

    button {
      width: 100%;
      margin: 3px 0;
    }
  }

  .elements-not-found {
    text-align: center;
    padding: 10px 0;
  }

  .input-with-cross {
    position: relative;
    width: 100%;

    input {
      padding-right: 30px;
      padding-left: 40px;
    }

    span, label {
      position: absolute;
      top: 7px;
      cursor: pointer;

      &.ic-search {
        right: initial;
        left: 7px;

        &:hover {
          color: var(--default-icon-color);
          cursor: default;
        }
      }

      &.ic-cross {
        right: 7px;
      }
    }
  }
}

</style>
